import { template } from "@ember/template-compiler";
import type { TOC } from '@ember/component/template-only';
import type Patient from 'parog-web/models/patient';
import DiagnosticFields from '../hemato-cancer/diagnostic-fields';
interface Signature {
    Args: {
        form?: unknown;
        patient: Patient;
    };
}
const MyComponent: TOC<Signature> = template(`
  <DiagnosticFields
    {{! @glint-expect-error }}
    @form={{@form}}
    @patient={{@patient}}
  />
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default MyComponent;
